import { create } from 'zustand';
import type { User } from 'firebase/auth';

interface AuthState {
  user: User | null;
  loading: boolean;
  authError: string | null;
  currentSessionId: string | null;
  isApprovedHost: boolean;
  isAdmin: boolean;

  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setAuthError: (error: string | null) => void;
  setCurrentSessionId: (sessionId: string | null) => void;
  setIsApprovedHost: (isApproved: boolean) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true, // Initially true while Firebase restores session from browserLocalPersistence
  authError: null,
  currentSessionId: null,
  isApprovedHost: false,
  isAdmin: false,

  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  setAuthError: (authError) => set({ authError }),
  setCurrentSessionId: (currentSessionId) => set({ currentSessionId }),
  setIsApprovedHost: (isApprovedHost) => set({ isApprovedHost }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  clearAuth: () =>
    set({
      user: null,
      loading: false,
      authError: null,
      currentSessionId: null,
      isApprovedHost: false,
      isAdmin: false,
    }),
}));

